import React, { useState, useEffect } from "react";
import "./orderThankyou.css";
import Header from "../../components/common/header";
import Footer from "../../components/common/footer";
import selsmartLogo from "../../assets/images/successfull icon.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUser } from "../../contexts/userContext";
import { useCart } from "../../contexts/cartContext";

const OrderThankyouPage = () => {
    const location = useLocation()
    const navigate = useNavigate();
    const { cartQuantity, setCartQuantity } = useCart();
  // //console.log("thank you page navigate prog id",prog_id)
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const orderNumber = location.state?.orderNumber
  const orderPickupDate = location.state?.pickupDate
  const emailId = location.state?.emailId
  const mobileNumber = location.state?.mobileNumber
  const {
    setSessionCode,fetchCsrfToken
  } = useUser();

  useEffect(() => {

    window.scrollTo({ top: 0, behavior: "smooth" });
    // fetchSeoMetaDetails()
  },[]);


const fetchSeoMetaDetails = async () => {
    try {
        const code = 'order_thankyou_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };

  const handleGotItClick = () => {
    // setShowModal(false); // Close the modal
    setSessionCode("");
    navigate("/"); // Redirect to home page
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  return (
    <div>
      <Header />
      <main className="main-content-order-thank-you-page container">
        
        <div className="order-thank-you-page">
        <img src={selsmartLogo} className="check-icon"></img>
        
                          <h3 className="order-thankyou">Thank you for using Selsmart!</h3>
                          <p className="order-thank-you-content-one">
                            Your order No. <strong>{orderNumber}</strong>{" "}
                            is successfully placed
                            {orderPickupDate ? (
                              <p>
                                and scheduled on{" "}
                                <strong>
                                  {orderPickupDate
                                    ? new Date(orderPickupDate).toLocaleDateString(
                                        "en-GB",
                                        {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                        }
                                      )
                                    : "N/A"}
                                </strong>{" "}
                                for pickup.
                              </p>
                            ) : (
                              "."
                            )}
                          </p>
                          <p className="order-thank-you-content">
                          We’ll keep you updated at:
                          </p>
                          <p className="order-thank-you-content">
                          <strong>Phone Number:</strong> {mobileNumber}
                          </p>
                          <p className="order-thank-you-content">
                          <strong>Email ID:</strong> {emailId}
                          </p>
                          <p className="order-thank-you-content">
                          If you have any questions, please contact our support team.
                          </p>
                          <button
                            className="got-it-button"
                            onClick={handleGotItClick}
                          >
                           Back to home
                          </button>
        
          {/* <h3 className="order-thankyou">Order successfully placed!</h3>
          <p className="order-number">Reference Order Number: <strong>{orderNumber}</strong> </p>
          <p className="thank-you-content-one">
          Thank you for using Selsmart! Your order has been successfully placed and scheduled for pickup.

          </p>
          <p className="thank-you-content">
          You will receive an email confirmation shortly with the details. If you have any questions, please contact our support team.
          </p>
          <p className="thank-you-content">
            Your Order Number has been sent via SMS to your Mobile Number and
            Email Id.
          </p>
          <div>
          <button>
            Back to home
          </button>
          </div> */}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default OrderThankyouPage;
